import { Link } from "@/components/common/Link";
import { ArrowLeft, CircleCheck, Phone, MessageCircle } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
const cities = [{
  name: "תל אביב",
  url: "/NurseInTelAvivWithinHoursPage"
}, {
  name: "רמת גן",
  url: "/NursingCaregiverInRamatGanWithinHoursPage"
}, {
  name: "חיפה",
  url: "/NursingCareProviderInHaifaWithinFiveHoursPage"
}, {
  name: "ירושלים",
  url: "/ContactPage"
}, {
  name: "פתח תקווה",
  url: "/ContactPage"
}, {
  name: "ראשון לציון",
  url: "/ContactPage"
}, {
  name: "אשדוד",
  url: "/ContactPage"
}, {
  name: "נתניה",
  url: "/ContactPage"
}];
const benefits = [{
  text: "זמינות מלאה 24/7 לכל קריאה דחופה"
}, {
  text: "צוות מטפלים ישראלים בלבד דוברי עברית"
}, {
  text: "שירות מקצועי בבית המטופל ובכל בתי החולים"
}, {
  text: "התאמה אישית ומדויקת של המטפל לצרכי המטופל"
}];
const faqItems = [{
  question: "תוך כמה זמן המטפל מגיע ליעד?",
  answer: "אנו מתחייבים להגעת מטפל סיעודי ישראלי תוך 5 שעות בלבד מרגע אישור הפנייה, בכל מקום בארץ."
}, {
  question: "האם השירות זמין גם בסופי שבוע וחגים?",
  answer: "כן, המוקד שלנו והמטפלים זמינים 24 שעות ביממה, 7 ימים בשבוע, כולל שבתות וחגי ישראל."
}, {
  question: "האם אתם מספקים שירותי השגחה בבתי חולים?",
  answer: "בוודאי. אנו מתמחים במתן שירותי השגחה פרטית בבתי חולים כדי להקל על המשפחה ולהבטיח טיפול צמוד למטופל."
}, {
  question: "איך מתבצע תהליך ההתאמה?",
  answer: "לאחר הפנייה, אנו מאבחנים את הצרכים הספציפיים ומתאימים את המטפל בעל הניסיון הרלוונטי ביותר למקרה שלכם."
}, {
  question: "מה קורה אם אין התאמה אישית בין המטפל למטופל?",
  answer: "הקשר הבינאישי הוא בלב השירות שלנו. במידה ונוצר מצב בו אין התאמה מלאה, אנו פועלים באופן מיידי להחלפת המטפל במטפל אחר שיתאים טוב יותר לאופי ולצרכי המטופל, ללא עיכובים מיותרים."
}];
export default function CaregiversInCities() {
  return <section id="מטפלים-סיעודיים-בערים" className="bg-background py-16 md:py-24" dir="rtl">
      <div className="container mx-auto px-4 max-w-7xl">
        <h1 className="font-default text-primary mb-6 text-right text-4xl font-bold md:text-6xl leading-tight">
          מטפל סיעודי עכשיו – שירות מהיר ומקצועי בפריסה ארצית
        </h1>
        <h2 className="font-default text-primary/80 mb-10 text-right text-2xl font-semibold md:text-3xl leading-tight">
          מטפלים סיעודיים בערים: פתרונות מיידיים ברגעי משבר
        </h2>

        <div className="mb-20 max-w-4xl text-right">
          <div className="space-y-6">
            <p className="text-foreground/80 text-xl leading-relaxed">
              אנו ב-Siudy מבינים שהצורך במטפל סיעודי הוא לעיתים קרובות עניין דחוף שאינו סובל דיחוי. השירות שלנו נולד כדי לגשר על הפער שבין הצורך המיידי לבין הבירוקרטיה וההמתנה הארוכה המאפיינת את התחום, תוך שמירה על רמה מקצועית גבוהה ויחס אישי ומסור. כאשר מצבו הבריאותי של אדם יקר משתנה בפתאומיות, המשפחה מוצאת את עצמה לא פעם במצב של חוסר אונים מול מערכת הבריאות הציבורית. בין אם מדובר בשחרור פתאומי מבית החולים, החמרה במצב כרוני או צורך בהשגחה צמודה לאחר ניתוח, הזמן הוא המשאב היקר ביותר שלכם.
            </p>
            <p className="text-foreground/80 text-lg leading-relaxed">
              היכולת להשיג <span className="text-ring font-bold">מטפל סיעודי בתל אביב</span> או בכל עיר אחרת תוך שעות ספורות היא לא רק עניין של נוחות – היא עניין של ביטחון נפשי ובריאותי. אנו ב-Siudy פיתחנו מודל עבודה ייחודי המאפשר לנו להגיב במהירות שיא, תוך סינון קפדני של המטפלים והתאמתם המדויקת למאפייני המטופל. אנחנו לא רק מספקים כוח אדם, אנחנו מספקים מעטפת של שקט נפשי למשפחה כולה.
            </p>
          </div>

          <div className="mt-16 mb-12">
            <h2 className="text-primary mb-6 text-3xl font-bold">החשיבות של טיפול מהיר ומיידי</h2>
            <h3 className="text-primary mb-4 text-2xl font-bold">הפתרון שלנו: מטפל סיעודי ישראלי תוך 5 שעות</h3>
            <div className="space-y-6">
              <p className="text-foreground/80 text-lg leading-relaxed">
                המערך המקצועי של Siudy פרוס בפריסה ארצית רחבה, מה שמאפשר לנו להתחייב להגעת מטפל סיעודי מיומן תוך 5 שעות בלבד. אנחנו כאן כדי לתת לכם מענה מהיר ומקצועי ברגעים שבהם אתם זקוקים לו ביותר, בין אם בבית המטופל ובין אם בהשגחה צמודה בבית החולים. השירות שלנו זמין עבורכם בכל רחבי הארץ, עם דגש על ערים מרכזיות. לדוגמה, אם אתם זקוקים לשירותי <span className="text-ring font-bold">מטפל סיעודי ברמת גן</span>, הצוות המקומי שלנו ערוך להגיע אליכם במהירות המרבית.
              </p>
              <p className="text-foreground/80 text-lg leading-relaxed">
                המהירות שלנו נובעת מתשתית לוגיסטית מתקדמת ומאגר מטפלים ישראלים זמינים שנבחרו בקפידה. אנו מבינים שכל דקה של המתנה ללא השגחה עלולה להיות קריטית, ולכן המוקד שלנו פועל במתכונת חירום 24/7. אנחנו לא נותנים לכם לחכות ימים או שבועות לאישורים; ברגע שיצרתם קשר, המכונה של Siudy נכנסת לפעולה כדי להבטיח שיקירכם לא יישאר לבד אפילו לרגע אחד מיותר.
              </p>
            </div>
          </div>

          <div className="mb-12">
            <h3 className="text-primary mb-6 text-2xl font-bold">היתרונות המרכזיים בשירות שלנו</h3>
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {benefits.map((benefit, i) => <li key={i} data-index={i} className="flex items-start gap-3 text-lg text-foreground/80 bg-card p-4 rounded-xl border border-border">
                  <CircleCheck className="text-ring h-6 w-6 shrink-0 mt-0.5" />
                  <span>{benefit.text}</span>
                </li>)}
            </ul>
          </div>

          <div className="mb-12">
            <h2 className="text-primary mb-4 text-3xl font-bold">תהליך ההתאמה המותאם אישית</h2>
            <h3 className="text-primary mb-4 text-2xl font-bold">טיפול מסור ומקצועי ללא פשרות</h3>
            <div className="space-y-6">
              <p className="text-foreground/80 text-lg leading-relaxed">
                כל המטפלים בצוות שלנו הם ישראלים בעלי ניסינה עשיר בתחום הסיעוד. אנו מקפידים על התאמה אישית ומדויקת לצרכי המטופל, תוך שימת דגש על כבוד, סבלנות ומסירות. השירות שלנו כולל ליווי מלא, סיוע פיזי ותמיכה רגשית למטופל ולמשפחתו. אנו מבינים שלכל מטופל יש את הצרכים הייחודיים שלו – החל ממצב רפואי ספציפי ועד להעדפות שפה ותרבות.
              </p>
              <p className="text-foreground/80 text-lg leading-relaxed">
                אנו פועלים בשקיפות מלאה מול המשפחות ומספקים דיווחים שוטפים על מצב המטופל. המטרה שלנו היא להעניק לכם שקט נפשי בידיעה שיקירכם נמצא בידיים הטובות והמקצועיות ביותר, ללא המתנה מייגעת. הצוות שלנו עובר הכשרות תקופתיות ומוודא שכל מטפל עומד בסטנדרטים הגבוהים ביותר של אתיקה ומקצועיות. בין אם מדובר בשירותי <span className="text-ring font-bold">מטפל סיעודי בחיפה</span> או בכל נקודה אחרת על המפה, האיכות נשארת אחידה וגבוהה.
              </p>
            </div>
          </div>

          <div className="mb-12">
            <h2 className="text-primary mb-6 text-3xl font-bold">דוגמאות ממקרים אמיתיים</h2>
            <div className="space-y-6">
              <p className="text-foreground/80 text-lg leading-relaxed">
                במהלך שנות פעילותנו, סייענו לאלפי משפחות ברגעי משבר. מקרה זכור במיוחד היה של משפחה מהמרכז שאביהם עבר אירוע מוחי פתאומי ביום שישי בערב. בתי החולים היו עמוסים, והמשפחה נדרשה להשגחה צמודה באופן מיידי. תוך פחות מ-4 שעות, מטפל מוסמך מטעמנו כבר התייצב ליד מיטת המטופל, מה שאפשר לבני המשפחה לנוח ולהתארגן להמשך הטיפול.
              </p>
              <p className="text-foreground/80 text-lg leading-relaxed">
                מקרה נוסף התרחש בצפון, כאשר מטופלת קשישה נזקקה לסיוע לאחר ניתוח ירך. הצורך היה במטפלת דוברת עברית שתדע גם לספק תמיכה מורלית. בזכות מאגר המטפלים הרחב שלנו, הצלחנו להתאים לה מטפלת בעלת רקע בשיקום פיזיותרפי, מה שתרם משמעותית למהירות ההחלמה שלה. סיפורים אלו הם ההוכחה שהשירות המהיר שלנו מציל חיים ומשפר את איכותם באופן יומיומי.
              </p>
            </div>
          </div>

          <div className="mb-12">
            <h3 className="text-primary mb-6 text-2xl font-bold">שאלות נפוצות</h3>
            <Accordion type="single" collapsible className="w-full">
              {faqItems.map((item, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-border">
                  <AccordionTrigger className="text-right text-lg font-semibold py-4 hover:no-underline">
                    {item.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-foreground/70 text-right text-base leading-relaxed pb-4">
                    {item.answer}
                  </AccordionContent>
                </AccordionItem>)}
            </Accordion>
          </div>

          <div className="flex flex-wrap gap-4 pt-4">
            <Button size="lg" className="bg-ring hover:bg-ring/90 text-white rounded-lg px-10 h-14 text-lg font-bold shadow-lg shadow-ring/20">
              <Phone className="ml-2 h-5 w-5" />
              התקשרו עכשיו לקבלת שירות
            </Button>
            <Button variant="outline" size="lg" className="border-ring text-ring hover:bg-accent rounded-lg px-10 h-14 text-lg font-bold">
              <MessageCircle className="ml-2 h-5 w-5" />
              וואטסאפ מיידי
            </Button>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
          {cities.map((city, i) => <Link key={i} data-index={i} to={city.url} className="group bg-card border-border hover:border-ring flex items-center justify-between rounded-2xl border px-6 py-4 transition-all duration-300 hover:shadow-sm">
              <span className="font-default text-foreground text-lg font-medium">
                {city.name}
              </span>
              <ArrowLeft className="text-ring h-5 w-5 transition-transform duration-300 group-hover:-translate-x-1" />
            </Link>)}
        </div>
      </div>
    </section>;
}